import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '../../services/shared/shared.service';
import { RoutingService } from '../../services/routing/routing.service';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { DialogService } from '../../services/dialog.service';

@Injectable()
export class RequestGuard {
  private _routingService = inject(RoutingService);
  private _sharedService = inject(SharedService);
  private _dialogService = inject(DialogService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((obs) => {
      this._sharedService.userData$
        .pipe(takeWhile((userData) => !userData, true))
        .subscribe((userData) => {
          if (!userData) {
            return;
          }

          if (userData.illOptions?.accessILLRequest) {
            obs.next(true);
            return;
          }

          if (userData.illOptions?.requestThisRequireLogin) {
            this._routingService.goToLogin(state.url);
            obs.next(false);
            return;
          } else {
            this._dialogService.openAlertDialog('', 'REQUEST.GUARD.MESSAGE').subscribe(() => {
              this._routingService.goToHome();
              obs.next(false);
            });
          }
        });
    });
  }
}

@Injectable()
export class RequestRoleGuard {
  private _sharedService = inject(SharedService);
  private _validRoles = ['lender', 'borrower'];

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const role = route.paramMap.get('role')?.toLowerCase();

    if (this._validRoles.includes(role)) {
      return true;
    }

    this._sharedService.redirect404();
    return false;
  }
}
